module.exports = __webpack_public_path__ + "img/logoDark.103321be.svg";